import { useCustomClient } from './use-custom-client'
const baseURL = import.meta.env.VITE_REST_CLIENT_OPENDATA_TARGET_URL
export const useOpendataSwaggerClient = <T>() => useCustomClient<T>(baseURL)
